var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1074 848L1074 876",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.5,
    cy: 843.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.99 843.19C1069.99 839.283 1073.29 836.117 1077.36 836.117C1077.94 836.117 1078.51 836.184 1079.06 836.308C1077.74 835.48 1076.19 835 1074.52 835C1069.81 835 1066 838.806 1066 843.5C1066 848.194 1069.81 852 1074.52 852C1076.81 852 1078.89 851.093 1080.43 849.62C1079.49 850.032 1078.45 850.263 1077.36 850.263C1073.29 850.263 1069.99 847.096 1069.99 843.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.4 842.6L1083.37 840.146L1081.54 841.719L1079.3 841.056L1080.11 843.337L1078.77 845.381L1081.1 845.218L1082.5 847.144L1083.13 844.763L1085.34 843.909L1083.4 842.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.f0368ea7bf9b4c30a72c485699bcb6e8.svg";
export { ForwardRef as ReactComponent };